import axios, {AxiosInstance} from 'axios';
import {APP_CONFIG} from '../lib/config/AppConfig';
const baseURL = APP_CONFIG.api.packman.uri;

const axiosInstance: AxiosInstance = axios.create({baseURL});
export {axiosInstance};
